/*
 * nextTab: number
 * // Key -> index associated with tab order
 * // Value -> Unique Section Key
 * enumSettings: Record<number, string>
 * // Key -> Unique Section Key
 * // Value -> Route to section
 * routeSettings: Record<string, string>
 */
export const getRouteToNextTab = (nextTab, enumSettings, routeSettings) => {
  const [, sectionKey] = Object.entries(enumSettings).find(([idx]) => parseInt(idx) === nextTab);

  const [, route] = Object.entries(routeSettings).find(([key]) => key === sectionKey);

  return route;
};

export const getCurrentSectionData = (
  sectionRoute,
  defaultSectionKey,
  routeSettings,
  enumSettings
) => {
  const [sectionKey] = Object.entries(routeSettings).find(
    ([, value]) => value === sectionRoute
  ) || [defaultSectionKey];

  const [tabIndex] = Object.entries(enumSettings).find(([, key]) => key === sectionKey);

  return {
    sectionKey,
    tabIndex
  };
};
